import React from 'react';

const StatusBadge = ({ status, type = 'blog' }) => {
  const getBadgeConfig = () => {
    if (type === 'blog') {
      switch (status) {
        case 'published':
          return { className: 'bg-success', text: 'Published' };
        case 'draft':
          return { className: 'bg-warning text-dark', text: 'Draft' };
        case 'inactive':
          return { className: 'bg-secondary', text: 'Inactive' };
        default:
          return { className: 'bg-light text-dark', text: status };
      }
    } else if (type === 'comment') {
      switch (status) {
        case 'approved':
          return { className: 'bg-success', text: 'Approved' };
        case 'pending':
          return { className: 'bg-warning text-dark', text: 'Pending' };
        case 'rejected':
          return { className: 'bg-danger', text: 'Rejected' };
        default:
          return { className: 'bg-light text-dark', text: status };
      }
    }
    return { className: 'bg-light text-dark', text: status };
  };

  const { className, text } = getBadgeConfig();

  return (
    <span className={`badge ${className} rounded-pill px-3 py-2 fw-medium`}>
      {text}
    </span>
  );
};

export default StatusBadge;